import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import classNames from 'classnames';

import ZendeskHelp from '@/shared/components/ZendeskHelp';
import messages from './InteractionSettingsMessages';

import { showWhenPermission } from '@/shared/components/security';
import { useStateService } from '@/shared/services/StateService';
import MailTemplateOverview from './MailTemplateOverview';
import InteractionTemplateOverview from './InteractionTemplateOverview';

const routeNames = ['EmailTemplates', 'NoteTemplates', 'MeetingTemplates', 'PhoneTemplates'];

const getInitialTab = tab => {
  if (!tab) return 0;
  if (typeof tab === 'string') {
    const idx = routeNames.findIndex(x => x.toLowerCase() === tab.toLowerCase());
    if (idx >= 0) return idx;
  }
  if (typeof tab === 'number' && tab >= 0 && tab < routeNames.length) {
    return tab;
  }

  return 0;
};

const InteractionTemplateSettingsContainer = ({ tab: initialTab }) => {
  const [tab, setTab] = useState(getInitialTab(initialTab));
  const intl = useIntl();
  const stateService = useStateService();
  const changeTab = useCallback(
    t => {
      setTab(t);
      stateService.gotoState('.', { tab: routeNames[t] });
    },
    [stateService],
  );

  return (
    <>
      <ul className="nav nav-tabs nav-tabs-heading" role="tablist">
        <li
          role="presentation"
          className={classNames('tab', { active: tab === 0 })}
          onClick={() => changeTab(0)}
        >
          <span>
            <FormattedMessage {...messages.EmailTemplates} />{' '}
            <ZendeskHelp article="5434788279570" />
          </span>
        </li>
        <li
          role="presentation"
          className={classNames('tab', { active: tab === 1 })}
          onClick={() => changeTab(1)}
        >
          <span>
            <FormattedMessage {...messages.NoteTemplates} />{' '}
            <ZendeskHelp article="19365890703900" />
          </span>
        </li>
        <li
          role="presentation"
          className={classNames('tab', { active: tab === 2 })}
          onClick={() => changeTab(2)}
        >
          <span>
            <FormattedMessage {...messages.MeetingTemplates} />{' '}
            <ZendeskHelp article="19365912851356" />
          </span>
        </li>
        <li
          role="presentation"
          className={classNames('tab', { active: tab === 3 })}
          onClick={() => changeTab(3)}
        >
          <span>
            <FormattedMessage {...messages.PhoneTemplates} />{' '}
            <ZendeskHelp article="19365929697692" />
          </span>
        </li>
      </ul>
      <div className="info-block-tab-panel panel">
        {tab === 0 ? (
          <MailTemplateOverview intl={intl} stateService={stateService} tab={tab} />
        ) : null}
        {tab === 1 ? (
          <InteractionTemplateOverview intl={intl} stateService={stateService} tab={tab} type={0} />
        ) : null}
        {tab === 2 ? (
          <InteractionTemplateOverview intl={intl} stateService={stateService} tab={tab} type={3} />
        ) : null}
        {tab === 3 ? (
          <InteractionTemplateOverview intl={intl} stateService={stateService} tab={tab} type={1} />
        ) : null}
      </div>
    </>
  );
};
InteractionTemplateSettingsContainer.propTypes = {
  tab: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.any]),
};
InteractionTemplateSettingsContainer.defaultProps = {
  tab: undefined,
};
export default showWhenPermission(['Settings', 'EmailAndInteractionTemplates'], 'read')(InteractionTemplateSettingsContainer);
